import React, { useState, useEffect } from 'react';
import { Button, Nav } from 'react-bootstrap';

import { getExternalUserInfo, getUserRequests, setExternalUserInfo } from '../../services/apiClient';

// Импорт иконок
import nav_icon_order from '../../img/nav-icon-order.svg';
import arrow_down_fill from '../../img/arrow-down-fill.svg';
import nav_icon_children from '../../img/nav-icon-children.svg';
import nav_link_profile from '../../img/nav-link-profile.svg';
import nav_link_answer from '../../img/nav-link-answer.svg';
import nav_link_massege from '../../img/nav-link-massege.svg';
import nav_link_appointment from '../../img/nav-link-appointment.svg';
import nav_link_base from '../../img/nav-link-base.svg';
import share from '../../img/share.svg';

const CabinetPageMenuLeft = ({ onMenuItemClick, onNewApplication, activeItem, onKnowledgeBaseClick, messagesInfo, isPossibleNew }) => {
  //const [activeItem, setActiveItem] = useState(part); 
  const [isApplicationsExpanded, setIsApplicationsExpanded] = useState(false);
  const [externalservice, setExternalService] = useState(null);

  const menuItems = [
    {
      id: 'applications',
      label: 'Заявки на вступ',
      icon: nav_icon_order,
      hasDropdown: true,
      href: '#',
      badge: null
    },
    {
      id: 'children',
      label: 'Діти в садочку',
      icon: nav_icon_children,
      hasDropdown: false,
      href: 'cabinet-children.html',
      badge: null
    },
    {
      id: 'profile',
      label: 'Мій профіль',
      icon: nav_link_profile,
      hasDropdown: false,
      href: '#',
      badge: null
    },
    {
      id: 'faq',
      label: 'Питання та відповіді',
      icon: nav_link_answer,
      hasDropdown: false,
      href: 'faq.html',
      badge: null
    },
    {
      id: 'messages',
      label: 'Мої повідомлення',
      icon: nav_link_massege,
      hasDropdown: false,
      href: 'messages.html',
      badge: messagesInfo.all
    },
    {
      id: 'appointment',
      label: 'Запис на прийом',
      icon: nav_link_appointment,
      hasDropdown: false,
      href: '#',
      badge: null
    }
  ];

  const handleMenuItemClick = (itemId, event) => {
    event.preventDefault();
    //setActiveItem(itemId);
    
    
    if (itemId === 'applications') {
      setIsApplicationsExpanded(!isApplicationsExpanded);
    }

 
    if (onMenuItemClick) {
      onMenuItemClick(itemId);
    }
  };

  const handleNewApplication = (event) => {
    event.preventDefault();
    
 
    if (onNewApplication) {
      onNewApplication('wizzard');
    }
  };

  useEffect(()=>{
    const exterS = getExternalUserInfo();
    if(exterS?.url) setExternalService(exterS);
    const userRequestsCount = getUserRequests();
    
    if(exterS?.url && !userRequestsCount) onNewApplication('wizzard');
    if( exterS?.url && userRequestsCount) onMenuItemClick('applications'); 
  },[]);

 

  return (
    <div className="sidebar-content">
      {/* Button Wrapper */}
      <div className="button-wrapper">
        <Button className="new-app-btn" onClick={handleNewApplication} disabled={!isPossibleNew}>
          <i className="fa-solid fa-plus me-2"></i>Нова заявка
        </Button>
      </div>
      
      {/* Sidebar Menu */}
      <nav className="sidebar-nav">
        <Nav className="flex-column">
          {menuItems.map((item) => (
            <Nav.Item key={item.id}>
              <Nav.Link
                href={item.href}
                className={activeItem === item.id ? 'menu-active' : ''}
                onClick={(e) => handleMenuItemClick(item.id, e)}
              >
                <img src={item.icon} alt={item.label} className="nav-icon" />
                <span>{item.label}</span>
                
                {item.hasDropdown && (
                  <img 
                    src={arrow_down_fill} 
                    alt="expand" 
                    className={`expand-icon ms-auto ${isApplicationsExpanded ? 'rotated' : ''}`}
                    style={{
                      transform: isApplicationsExpanded ? 'rotate(180deg)' : 'none',
                      transition: 'transform 0.2s ease'
                    }}
                  />
                )}
                
                {item.badge && (
                  <span className="badge bg-primary ms-auto">{item.badge}</span>
                )}
                
                {!item.hasDropdown && !item.badge && (
                  <div className="ms-auto" style={{ width: '16px' }}></div>
                )}
              </Nav.Link>
              
              {/* Подменю для заявок (если раскрыто) */}
              {item.id === 'applications' && isApplicationsExpanded && (
                <div className="submenu">
                  <Nav className="flex-column">
                    <Nav.Item>
                      <Nav.Link 
                        href="#active" 
                        className={`submenu-item ${ ["applications_act", "applications"].includes(activeItem) ? 'menu-active' : '' }` }
                        style={{ marginLeft: '12%'}}
                        onClick={(e) => handleMenuItemClick('applications_act', e)}
                      >
                        Активні заявки
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link 
                        href="#completed" 
                        className={`submenu-item ${ ["applications_closed"].includes(activeItem) ? 'menu-active' : '' }` }
                        style={{ marginLeft: '12%'}}
                        onClick={(e) => handleMenuItemClick('applications_closed', e)}
                      >
                        Завершені заявки
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link 
                        href="#drafts" 
                        className={`submenu-item ${ ["applications_removed"].includes(activeItem) ? 'menu-active' : '' }` }
                        style={{ marginLeft: '12%'}}
                        onClick={(e) => handleMenuItemClick('applications_removed', e)}
                      >
                        Видалені заявки
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
              )}
            </Nav.Item>
          ))}
        </Nav>
        
        <div className="nav-divider"></div>
        
        <div className="knowledge-base">
          <Nav.Link 
            href="#" 
            className="knowledge-link"
            onClick={(e) => {
              //e.preventDefault();
              if (onKnowledgeBaseClick) {
                onKnowledgeBaseClick();
              }
            }}
          >
            <img src={nav_link_base} alt="Book" className="nav-icon" />
            <span>База знань</span>
            <img src={share} alt="Share" className="nav-icon-share ms-2" />
          </Nav.Link>
        </div>

        { externalservice?.url && <div className="knowledge-base">
          <Nav.Link 
            href="#" 
            className="knowledge-link"
            onClick={(e) => {
              //e.preventDefault();
              setExternalUserInfo(null);
              window.location.href = externalservice.url
            }}
          >
            <img src={nav_link_base} alt="Book" className="nav-icon" />
            <span>Повернутись до {externalservice?.name} </span>
            <img src={share} alt="Share" className="nav-icon-share ms-2" />
          </Nav.Link>
        </div>}



      </nav>
    </div>
  );
};

// Пропсы по умолчанию
CabinetPageMenuLeft.defaultProps = {
  initialActiveItem: 'profile',
  onMenuItemClick: null,
  onNewApplication: null,
  onKnowledgeBaseClick: null
};

export default CabinetPageMenuLeft;